import colors from "../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const NavigationBarStyle = makeStyles((theme) => ({
	headerLogoLeft: {
		float: "right",
		padding: "20px",
		width: "220px",
		float: "left",
		[theme.breakpoints.down("md")]: {
			width: "175px",
		},
		[theme.breakpoints.down("sm")]: {
			width: "100px",
		},
	},
	headerLogoRight: {
		float: "right",
		padding: "35px 20px 0px 0px",
		width: "235px",

		[theme.breakpoints.down("md")]: {
			width: "175px",
		},
		[theme.breakpoints.down("sm")]: {
			width: "100px",
			display: "none",
		},
	},
	headerText: {
		position: "absolute",
		display: "flex",
		marginTop: "50px",
		color: colors.white,
		width: "100%",
		justifyContent: "center",
		fontSize: "2em",

		[theme.breakpoints.down("md")]: {
			fontSize: "1.5em",
		},
		[theme.breakpoints.down("sm")]: {
			fontSize: "1em",
			justifyContent: "right",
			marginTop: "25px",
			width: "75%",
			display: "inline-flex",
			paddingRight: "10px",
		},
	},
	navbar: {
		overflow: "hidden",
		boxShadow: `0px 5px 5px -9px ${colors.softShadowAlpha}, 0px -2px 10px 1px ${colors.mediumShadowAlpha}, 0px 3px 14px 2px ${colors.mediumShadowAlpha2}`,
		backgroundColor: colors.primary,
		borderBottom: `1px solid ${colors.gainsboroLike}`,
		position: "relative",
		paddingBottom: theme.spacing(1),
	},
	logoutButton: {
		color: colors.charcoalGray,
		textTransform: "none",
		position: "sticky",
	},
	logoutLabel: {
		marginLeft: theme.spacing(0.75),
		marginRight: theme.spacing(0.75),
	},
}));

export default NavigationBarStyle;
